"use strict";
/**
 * 获取 query string
 *
 * ### Example
 * ```
 * const token = getQueryString('token');
 * const entry = getQueryString('entry');
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var decode_1 = require("./decode");
function getQueryString(name) {
    var arr = location.search.substr(1).split('&');
    for (var i = 0, l = arr.length; i < l; i++) {
        var item = arr[i].split('=');
        if (item.shift() === name) {
            return decode_1.decode(item.join('='));
        }
    }
    return '';
}
exports.getQueryString = getQueryString;
